import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-add-gray",
  "use": "app-icon-add-gray-usage",
  "viewBox": "0 0 31 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 31\" id=\"app-icon-add-gray\"><path d=\"M13 13V0h5v13h13v5H18v13h-5V18H0v-5h13z\" fill=\"#9FA2B4\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol